"use client";

import styles from "./Checkbox.module.scss";
import classNames from "classnames";
import * as CheckboxBase from "@radix-ui/react-checkbox";
import { CheckIcon } from "../icons";
import { ReactNode } from "react";

const CheckboxLabel = ({ children }: { children: ReactNode | string }) => {
  return <div>{children}</div>;
};

const CheckboxCaption = ({ children }: { children: ReactNode | string }) => {
  return <div className={styles["comp__caption"]}>{children}</div>;
};

const Checkbox = ({
  defaultValue = false,
  checked = undefined,
  children,
  id,
  onChange = () => {},
  variant = "primary",
  disabled = false,
}: {
  defaultValue?: boolean;
  checked?: boolean | "indeterminate" | undefined;
  children?: ReactNode;
  id: string;
  onChange?: (value: boolean) => void;
  variant?: "default" | "lightAlert" | "primary";
  disabled?: boolean;
}) => {
  return (
    <div className={styles["comp"]}>
      <CheckboxBase.Root
        disabled={disabled}
        onCheckedChange={(value) => onChange(value === true)}
        defaultChecked={defaultValue}
        className={classNames(
          styles["comp__root"],
          styles[`comp__root--${variant}`],
        )}
        checked={checked}
        id={id}
      >
        <CheckboxBase.Indicator
          className={classNames(
            styles["comp__indicator"],
            styles[`comp__indicator--${variant}`],
            checked === "indeterminate" && styles["comp__indicator--indeterminate"],
          )}
        >
          {checked === "indeterminate" ? (
            <span className={styles["comp__dash"]} aria-hidden />
          ) : (
            <CheckIcon />
          )}
        </CheckboxBase.Indicator>
      </CheckboxBase.Root>

      {children && (
        <label
          className={classNames(
            styles["comp__label"],
            styles[`comp__label--${variant}`],
          )}
          htmlFor={id}
        >
          {children}
        </label>
      )}
    </div>
  );
};

Checkbox.Label = CheckboxLabel;
Checkbox.Caption = CheckboxCaption;
export { Checkbox, CheckboxLabel, CheckboxCaption };
